export default ":host,\r\n.text-black {\r\n\tcolor: black;\r\n}\r\n"